import React, { useState, useEffect } from 'react';
import './InFlightMobile.css';

const REFRESH_INTERVAL_MS = 30000; // 30 seconds

const InFlightMobile = ({ flightData, onFlightClick }) => {
    const [secondsLeft, setSecondsLeft] = useState(REFRESH_INTERVAL_MS / 1000);
    const [dark, setDark] = useState(() => {
        const saved = localStorage.getItem('ifm-dark-mode');
        return saved !== null ? saved === 'true' : true;
    });

    useEffect(() => {
        setSecondsLeft(REFRESH_INTERVAL_MS / 1000);
        const tick = setInterval(() => {
            setSecondsLeft(s => (s <= 1 ? REFRESH_INTERVAL_MS / 1000 : s - 1));
        }, 1000);
        return () => clearInterval(tick);
    }, [flightData]);

    const toggleDark = () => {
        setDark(prev => {
            localStorage.setItem('ifm-dark-mode', String(!prev));
            return !prev;
        });
    };

    const mm = String(Math.floor(secondsLeft / 60)).padStart(2, '0');
    const ss = String(secondsLeft % 60).padStart(2, '0');

    return (
        <div className={`ifm-wrapper${dark ? '' : ' ifm-light'}`}>

            {/* ── Sticky header ── */}
            <div className="ifm-header">
                <span className="ifm-title">FLIGHTS IN PROGRESS</span>
                <span className="ifm-refresh">
                    Refreshes in <strong>{mm}:{ss}</strong>
                </span>
                <button className="ifm-theme-toggle" onClick={toggleDark} aria-label="Toggle dark mode">
                    {dark ? '☀' : '☾'}
                </button>
            </div>

            {/* ── Empty state ── */}
            {(!flightData || flightData.length === 0) ? (
                <div className="ifm-empty">No flights currently in progress</div>
            ) : (
                <div className="ifm-cards">
                    {flightData.map((flight, index) => (
                        <div
                            key={flight.id}
                            className="ifm-card"
                            onClick={() => onFlightClick && onFlightClick(index, flight)}
                        >
                            {/* ── Header: aircraft only ── */}
                            <div className="ifm-card-header">
                                <span className="ifm-card-acft">{flight.eqpt}</span>
                            </div>

                            {/* ── Route row ── */}
                            <div className="ifm-card-route">
                                {/* Callsign + Airports */}
                                <div className="ifm-route-airports">
                                    <div className="ifm-route-item">
                                        <span className="ifm-label">CALLSIGN</span>
                                        <span className="ifm-value ifm-callsign">{flight.user}</span>
                                    </div>
                                    <span className="ifm-route-divider">|</span>
                                    <div className="ifm-route-item">
                                        <span className="ifm-label">FROM</span>
                                        <span className="ifm-value ifm-airport">{flight.orig}</span>
                                    </div>
                                    <span className="ifm-route-arrow">›</span>
                                    <div className="ifm-route-item">
                                        <span className="ifm-label">TO</span>
                                        <span className="ifm-value ifm-airport">{flight.dest}</span>
                                    </div>
                                </div>

                                {/* ETA — right side */}
                                <div className="ifm-route-eta">
                                    <span className="ifm-label">ETA</span>
                                    <span className="ifm-value">
                                        {flight.eta === 'Arrived'
                                            ? <span className="ifm-arrived">ARR</span>
                                            : flight.eta.substring(0, 5)
                                        }
                                    </span>
                                </div>
                            </div>

                            {/* ── Stats grid: KTS · ALT · NM · DTG · TTG ── */}
                            <div className="ifm-card-stats">
                                <div className="ifm-stat">
                                    <span className="ifm-label">KTS</span>
                                    <span className="ifm-value">{flight.spd}</span>
                                </div>
                                <div className="ifm-stat">
                                    <span className="ifm-label">ALT</span>
                                    <span className="ifm-value">{flight.alt}</span>
                                </div>
                                <div className="ifm-stat">
                                    <span className="ifm-label">NM</span>
                                    <span className="ifm-value">{flight.dtr}</span>
                                </div>
                                <div className="ifm-stat">
                                    <span className="ifm-label">DTG</span>
                                    <span className="ifm-value">{flight.dtg}</span>
                                </div>
                                <div className="ifm-stat">
                                    <span className="ifm-label">TTG</span>
                                    <span className="ifm-value">{flight.ttg}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* ── Footer ── */}
            <div className="ifm-footer">
                {flightData ? flightData.length : 0} flight{flightData && flightData.length !== 1 ? 's' : ''} · refreshes every 30 sec
            </div>

        </div>
    );
};

export default InFlightMobile;
